<template>
  <el-dialog title="跟进回复" :visible.sync="dialogVisible" width="30%">
    <el-form ref="added" size="medium">
      <el-form-item label="跟进回复内容：" required>
        <el-input type='textarea' rows='7' :maxlength='500' show-word-limit v-model="reply_content"
          placeholder="请输入回复内容" clearable style="width: 100%;">
        </el-input>
      </el-form-item>
      <el-button type="primary" @click="handelConfirm">提交回复</el-button>
    </el-form>
    <div v-if="commentList.length" style="margin-top: 30px;">
      <div class="item" v-for="(item,i) in commentList" :key="i">
        <div class="flexbox">
          <div>{{ item.reply_role_name }}: {{ item.reply_content }}</div>
          <i v-if="userInfo.uid == item.uid" class="el-icon-delete-solid" @click="del(item)"></i>
        </div>
        <div style="opacity: 0.6;">{{ item.reply_time }}</div>
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible=false">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import userInfoAPI from '@/api/api';
  export default {
    data() {
      return {
        dialogVisible: false,
        commentList: [],
        reply_content: '',
        LogCommentItem: '',
        userInfo: ''
      }
    },
    methods: {
      show(row) {
        userInfoAPI.getUserInfo().then(res => {
          this.userInfo = res.data.data
          this.LogCommentItem = row
          this.getCommentReplyList()
          this.dialogVisible = true
        })
      },
      handelConfirm() {
        if (!this.reply_content.trim()) {
          this.$message({
            type: 'error',
            message: '请输入跟进内容'
          });
          return
        }
        userInfoAPI.followUpReply({
          customer_id: this.LogCommentItem.customer_id,
          follow_up_log_id: this.LogCommentItem.log_id,
          reply_content: this.reply_content,
        }).then((res) => {
          if (res.data.code == 0) {
            this.getCommentReplyList()
            this.reply_content = ''
            this.$message({
              type: 'success',
              message: res.data.msg
            })
          } else {
            this.$message({
              type: 'error',
              message: res.data.msg
            })
          }
        })
      },
      getCommentReplyList() { // 评价回复列表
        userInfoAPI.followUpReplyList({
          customer_id: this.LogCommentItem.customer_id,
          follow_up_log_id: this.LogCommentItem.log_id,
          page_limit: 999,
          page: 1
        }).then((res) => {
          this.commentList = res.data.data.list || []
        })
      },
      del(item) {
        this.$confirm('此操作将永久删除该跟进记录, 是否继续?', '删除提醒', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          userInfoAPI.followUpReplyDelete({
            reply_id: item.reply_id
          }).then((res) => {
            if (res.data.code == 0) {
              this.getCommentReplyList()
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
            } else {
              this.$message({
                type: 'success',
                message: res.data.msg
              })
            }
          })
        })
      },
    }
  }
</script>

<style scoped lang="scss">
  .item {
    margin-bottom: 10px;

    .flexbox {
      justify-content: space-between;
      display: flex;
      margin-bottom: 5px;
      text-align: justify;

      i {
        cursor: pointer;

        &:hover {
          color: red;
        }
      }
    }
  }
</style>
